export default __webpack_public_path__ + "static/media/profiili.8aaf8d9b.svg";